"use client";
import { l as d, I as g, y as p, z as u, c as C, x as h, j as m } from "./index-B6eLFvxS.js";
function f() {
  return "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1";
}
function w() {
  return !!window.cast?.framework;
}
function E() {
  return !!window.chrome?.cast?.isAvailable;
}
function c() {
  return s().getCastState() === cast.framework.CastState.CONNECTED;
}
function s() {
  return window.cast.framework.CastContext.getInstance();
}
function l() {
  return s().getCurrentSession();
}
function v() {
  return l()?.getSessionObj().media[0];
}
function k(r) {
  return v()?.media.contentId === r?.src;
}
function y() {
  return {
    language: "en-US",
    autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
    receiverApplicationId: chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
    resumeSavedSession: !0,
    androidReceiverCompatible: !0
  };
}
function S(r) {
  return `Google Cast Error Code: ${r}`;
}
function A(r, e) {
  return d(s(), r, e);
}
class I {
  name = "google-cast";
  target;
  #e;
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastContext}
   */
  get cast() {
    return s();
  }
  mediaType() {
    return "video";
  }
  canPlay(e) {
    return g && !p && u(e);
  }
  async prompt(e) {
    let t, a, o;
    try {
      t = await this.#r(e), this.#e || (this.#e = new cast.framework.RemotePlayer(), new cast.framework.RemotePlayerController(this.#e)), a = e.player.createEvent("google-cast-prompt-open", {
        trigger: t
      }), e.player.dispatchEvent(a), this.#t(e, "connecting", a), await this.#o(C(e.$props.googleCast)), e.$state.remotePlaybackInfo.set({
        deviceName: l()?.getCastDevice().friendlyName
      }), c() && this.#t(e, "connected", a);
    } catch (n) {
      const i = n instanceof Error ? n : this.#a(
        (n + "").toUpperCase(),
        "Prompt failed."
      );
      throw o = e.player.createEvent("google-cast-prompt-error", {
        detail: i,
        trigger: a ?? t,
        cancelable: !0
      }), e.player.dispatch(o), this.#t(
        e,
        c() ? "connected" : "disconnected",
        o
      ), i;
    } finally {
      e.player.dispatch("google-cast-prompt-close", {
        trigger: o ?? a ?? t
      });
    }
  }
  async load(e) {
    if (h)
      throw Error("[vidstack] can not load google cast provider server-side");
    if (!this.#e)
      throw Error("[vidstack] google cast player was not initialized");
    return new (await import("./vidstack-BeT6vBOi-KmXww_uT.js")).GoogleCastProvider(this.#e, e);
  }
  async #r(e) {
    if (w()) return;
    const t = e.player.createEvent("google-cast-load-start");
    e.player.dispatch(t), await m(f()), await customElements.whenDefined("google-cast-launcher");
    const a = e.player.createEvent("google-cast-loaded", { trigger: t });
    if (e.player.dispatch(a), !E())
      throw this.#a("CAST_NOT_AVAILABLE", "Google Cast not available on this platform.");
    return a;
  }
  async #o(e) {
    this.#s(e);
    const t = await this.cast.requestSession();
    if (t)
      throw this.#a(
        t.toUpperCase(),
        S(t)
      );
  }
  #s(e) {
    this.cast?.setOptions({
      ...y(),
      ...e
    });
  }
  #t(e, t, a) {
    const o = { type: "google-cast", state: t };
    e.notify("remote-playback-change", o, a);
  }
  #a(e, t) {
    const a = Error(t);
    return a.code = e, a;
  }
}
var P = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  GoogleCastLoader: I
});
export {
  s as getCastContext,
  S as getCastErrorMessage,
  l as getCastSession,
  v as getCastSessionMedia,
  k as hasActiveCastSession,
  A as listenCastContextEvent,
  P as loader
};
